import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import {Router} from '@angular/router';
import { MatDialog } from '@angular/material';
import { ChangePasswordComponent } from 'src/app/dialogs/change-password/change-password.component';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})

export class ToolbarComponent implements OnInit {

  appuser: any;
  constructor(private router: Router, private dialog: MatDialog) { }

  ngOnInit() {
    this.appuser=JSON.parse(localStorage.getItem('userdata'));
    if(this.appuser && (this.appuser.account_activation_requested=='1' || this.appuser.reset_requested=='1'))
      setTimeout(()=>{
        this.changePassword();
      },10)
  }
  changePassword(){
    const dialogRef = this.dialog.open(ChangePasswordComponent, {
      disableClose :true,
      width: '500px',
      data: {  }
    });

    dialogRef.afterClosed().subscribe(result => {});
  }
  logout(){

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger'
      },
      buttonsStyling: false
    })

    swalWithBootstrapButtons.fire({
      title: 'logout ?',
      text: "You are logging out...",
      showCancelButton: true,
      confirmButtonText: 'Yes Confirm',
      cancelButtonText: 'No, cancel!',
      reverseButtons: true
    }).then((result) => {
      if (result.value) {
        // swalWithBootstrapButtons.fire(
        //   'Deleted!',
        //   'Your file has been deleted.',
        //   'success'
        // )


    window.localStorage.clear();
    this.router.navigate(['']);

      } else (
        /* Read more about handling dismissals below */
        result.dismiss === Swal.DismissReason.cancel
      )

    })
}

  userprofile(){
    // router here.
  }
}
